import baseAPI from '@/api/base';
import { DeleteEmployeeSalaryPromotion, EditEmployeeSalaryPromotion, GetEmployeeSalaryPromotion, RegisterEmployeeSalaryPromotion } from '@/dtos/employee_salary_promotion.dto';
import {
  DELETE_EMPLOYEE_SALARY_PROMOTION_URL,
  EDIT_EMPLOYEE_SALARY_PROMOTION_URL,
  GET_EMPLOYEE_SALARY_PROMOTION_URL,
  REGISTER_EMPLOYEE_SALARY_PROMOTION_URL,
  TOGGLE_EMPLOYEE_SALARY_PROMOTION_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeSalaryPromotion {
  static getEmployeeSalaryPromotions = async (getEmployeeSalaryPromotion: GetEmployeeSalaryPromotion): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_SALARY_PROMOTION_URL, {
      params: getEmployeeSalaryPromotion,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeSalaryPromotion = async (
    registerEmployeeSalaryPromotion: RegisterEmployeeSalaryPromotion
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_SALARY_PROMOTION_URL, {
      ...registerEmployeeSalaryPromotion,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeSalaryPromotion = async (editEmployeeSalaryPromotion: EditEmployeeSalaryPromotion): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_SALARY_PROMOTION_URL, {
      ...editEmployeeSalaryPromotion,
    });
    return response;
  };

  static toggleEmployeeSalaryPromotionIsActive = async (
    editEmployeeSalaryPromotion: EditEmployeeSalaryPromotion
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_SALARY_PROMOTION_IS_ACTIVE_URL,
      {
        ...editEmployeeSalaryPromotion,
      }
    );
    return response;
  };

  static deleteEmployeeSalaryPromotion = async (deleteEmployeeSalaryPromotion: DeleteEmployeeSalaryPromotion): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_SALARY_PROMOTION_URL}/${deleteEmployeeSalaryPromotion.id}/${deleteEmployeeSalaryPromotion.employeeId}`
    );
    return response;
  };
}

export default EmployeeSalaryPromotion;
